// 开讲

const Home = () => import('../page/home/Home.page');
const Index = () => import('../page/Home.page');
const GroupAlbum = () => import('../page/GroupAlbum.page');
const SerialList = () => import('../page/SerialList.page');
const TagsSubjectPage = () => import('../page/TagsSubject.page');
const FreeClass = () => import('../page/index/FreeClass.page');
const LamaList = () => import('../page/LamaList.page');
const HqClass = () => import('../page/HqClass.page');
const SubscriptionList = () => import('../page/index/SubscriptionList.page');
const AuditionList = () => import('../page/index/AuditionList.page');
const ColumnList = () => import('../page/index/ColumnList.page');
const MemberFreeCourse = () => import('../page/member/MemberFreeCourse/MemberFreeCourse.page');

export default [
  // 缺省主页
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      pageTitle: '精品课',
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 老版主页
  {
    path: '/index',
    name: 'index',
    component: Index,
    meta: {
      pageTitle: '开讲',
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 组合课程列表页
  {
    path: '/groupalbum',
    name: 'GroupAlbum',
    component: GroupAlbum,
    meta: {
      pageTitle: '组合课',
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 系列课列表
  {
    path: '/serial/list',
    name: 'SerialList',
    component: SerialList,
    meta: {
      pageTitle: '系列课列表页',
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 标签页聚合页
  {
    path: '/tagsSubject/:tagId/:name/:subject',
    name: 'TagsSubjectPage',
    component: TagsSubjectPage,
    meta: {
      pageTitle: '标签聚合页',
      requiresAuth: false
    }
  },

  /* 免费课列表 */
  {
    path: '/freeClass',
    name: 'FreeClass',
    component: FreeClass,
    meta: {
      pageTitle: '服务',
      requiresAuth: false,
      authType: 'user'
    }
  },

  /* 为孕育推荐免费小微课 */
  {
    path: '/lamaList',
    name: 'lamaList',
    component: LamaList,
    meta: {
      pageTitle: '音频',
      requiresAuth: false,
      authType: 'user'
    }
  },

  /* 订阅课子课程列表 */
  {
    path: '/subscription/list/:liveId',
    name: 'SubscriptionList',
    component: SubscriptionList,
    meta: {
      pageTitle: '订阅专栏',
      requiresAuth: true,
      authType: 'user'
    }
  },
  /* 精品课列表 */
  {
    path: '/hqClass',
    name: 'hqClass',
    component: HqClass,
    meta: {
      pageTitle: '精品课',
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 订阅课列表
  {
    path: '/columnList',
    name: 'ColumnList',
    component: ColumnList,
    meta: {
      pageTitle: '订阅专栏',
      requiresAuth: false,
      authType: 'user'
    }
  },

  /* 试听列表 */
  {
    path: '/auditionList/:liveId',
    name: 'AuditionList',
    component: AuditionList,
    meta: {
      pageTitle: '订阅专栏',
      requiresAuth: false,
      authType: 'user'
    }
  },

  /* 会员免费听 */
  {
    path: '/member/listen',
    name: 'MemberFreeCourse',
    component: MemberFreeCourse,
    meta: {
      pageTitle: '会员免费听',
      requiresAuth: false,
      authType: 'user'
    }
  }
];




// WEBPACK FOOTER //
// ./src/user/router/entry.js